/**
 * @ngdoc component
 * @name myAccount.returns.component:itxMyAccountOrderRefundFORM
 *
 *
 * @description
 * FORM description of product refund.
 * This component will show
 *
 */
(function () {
    'use strict';

    var ItxMyAccountOrderRefundFormCmp = {
        bindings: {
            order: '=',
            typelegacy: '<',
        },
        controller: ItxMyAccountOrderRefundFormCmpCtrl,
        templateUrl: 'order-refund-form.component.html'
    };

    ItxMyAccountOrderRefundFormCmpCtrl.$inject = ['$rootScope', '$http', '$timeout'];

    function ItxMyAccountOrderRefundFormCmpCtrl( $rootScope, $http, $timeout) {
        var _this = this;
        _this.loadStyles = false;

        _this.$onInit = function () {
            if (_this.typelegacy === 'none') {
                const box = document.getElementById('dialogRefund');
                if(!inditex.LegacyCssCached){
                    // https://static.massimodutti.net/3/static2/itxwebstandard/css/legacy.css?t=202211110200031351298367
                    $http.get(window.staticContent + 'itxwebstandard/css/legacy.css?t=' + inditex.iRegistryTs).then(function (resp) {
                        inditex.LegacyCssCached = resp.data;
                        _this.loadStyles = true;
                        box.appendChild(Object.assign(document.createElement('style'), { innerHTML: inditex.LegacyCssCached }));
                        $timeout();
                    });
                } else {
                    box.appendChild(Object.assign(document.createElement('style'), { innerHTML: inditex.LegacyCssCached }));
                    _this.loadStyles = true;
                    $timeout();
                }
            } else {
                _this.loadStyles = true;
                $timeout();
            }
            _this.refundCompleted = false;
        };

        _this.refundComplete = function () {
            _this.refundCompleted = true;
        };

    }

    angular.module('itxApp.legacy')
        .component('itxMyAccountOrderRefund2Form', ItxMyAccountOrderRefundFormCmp);
})();
